/* The footer's status pill — colours itself from status.gethumandesign.com.
 *
 * The pill ships grey and says "Status" (see partials/footer.html). Only a
 * reading it actually got upgrades it to green, amber or red. Everything that
 * can go wrong — offline, blocked by an extension, CORS, a mid-deploy 404, a
 * watchdog that has stopped publishing — resolves to the same answer: leave it
 * exactly as the HTML shipped it. A green dot nobody measured is worse than no
 * dot, because it is the one thing on the page that a visitor would believe
 * during an outage.
 *
 * The verdict itself is computed once, in the status Worker's cron sweep, and
 * published as a ~110-byte summary. That is deliberate: the alternative is a
 * second copy of the banner rules here, drifting away from the status page's,
 * and 45 KB of ninety-day history pulled on every landing-page view to colour
 * one dot.
 */
(function () {
  "use strict";

  var ENDPOINT = "https://status.gethumandesign.com/api/status/summary";

  /* How old the *oldest* component's check may get before we stop claiming
   * anything. The probes do not share a cadence — most run every five minutes,
   * the chat and engine checks every fifteen — so this is three misses of the
   * slowest one. The status page's own note uses 20 minutes because it asks a
   * different question (is the monitor alive at all, which the newest check
   * answers); a pill that says "all systems" has to age out on the component
   * that has been quiet longest, or one stalled probe family leaves it green
   * forever.
   *
   * Measured against the reader's clock rather than a second timestamp in the
   * payload, for the reason status.js gives: the monitor writing the checks and
   * the watchdog publishing them can stall independently, and two fields from
   * the same payload cannot see the second one stop. */
  var STALE_MS = 45 * 60 * 1000;

  function paint(el, state) {
    var label = el.getAttribute("data-label-" + state);
    if (!label) return; // unknown / unrecognised state: stay grey and say "Status"
    var node = el.querySelector(".footer-status-label");
    if (node) node.textContent = label;
    el.setAttribute("data-state", state);
  }

  function load(el) {
    fetch(ENDPOINT, { cache: "no-store" })
      .then(function (res) {
        if (!res.ok) throw new Error("status HTTP " + res.status);
        return res.json();
      })
      .then(function (data) {
        if (!data || !data.state || !data.oldest_check_at) return;
        if (Date.now() - new Date(data.oldest_check_at).getTime() > STALE_MS) return;
        paint(el, data.state);
      })
      .catch(function () {
        /* We don't know, so we don't say. */
      });
  }

  document.addEventListener("DOMContentLoaded", function () {
    var el = document.getElementById("footer-status");
    if (!el || !window.fetch) return;

    // Below the fold by definition — nothing here may compete with the page's
    // own content for bandwidth before anyone has scrolled to it.
    var start = function () {
      load(el);
    };
    if (!("IntersectionObserver" in window)) {
      setTimeout(start, 3000);
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          io.disconnect();
          start();
          return;
        }
      },
      { rootMargin: "200px" },
    );
    io.observe(el);
  });
})();
